module.exports = __webpack_public_path__ + "static/media/6_връзки_с_инвeститорите_20170631.090859fc.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2017/6_връзки_с_инвeститорите_20170631.pdf
// module id = 155
// module chunks = 0